import { inject, Injectable } from '@angular/core';
import { MockService } from '@mock/mock.service';
import { delay, Observable } from 'rxjs';
import { IApiResponse } from '@app/api/interfaces/common/api-response.interface';
import { convertStringInToSumOfAllCharacters } from '@app/shared/utils/string';
import { ChartDataSoundStatus } from '@app/core/enums/chart-data-sound-status.enum';
import {
  ILowestDecibelDateChartData,
  ILowestDecibelDateChartDataQueryParams,
  ILowestDecibelDateChartDataRange,
  ILowestDecibelDateChartDataValue,
} from '@app/api/interfaces/chart-data/date-lowest-decibel';
import { LoggerDeploymentsDataMockService } from '@mock/data-services/logger-deployments-data-mock.service';
import { ILoggerDeploymentData } from '@app/api/interfaces/logger-deployment-data.interface';
import { generateDateDateChartData, sortByDate } from '@mock/utils/date-chart-data';

@Injectable({ providedIn: 'root' })
export class LoggerDeploymentDateLowestDecibelMockService extends MockService {
  private loggerDeploymentsDataMockService = inject(LoggerDeploymentsDataMockService);

  public get(
    projectId: string,
    deploymentId: string,
    filter: ILowestDecibelDateChartDataQueryParams
  ): Observable<IApiResponse<ILowestDecibelDateChartData, object>> {
    const deployment = this.loggerDeploymentsDataMockService.loggerDeploymentsData.find(
      el => el.deploymentId === deploymentId
    );

    const dataAll: ILowestDecibelDateChartData = deployment
      ? this.generateAccordingToDeployment(deployment)
      : { ranges: [] };

    const data = sortByDate<ILowestDecibelDateChartDataValue, ILowestDecibelDateChartDataRange>(dataAll, filter);

    return this.mockResponse<IApiResponse<ILowestDecibelDateChartData, object>>(
      'LOGGER_DEPLOYMENT_DATE-LOWEST_DECIBEL:get',
      {
        data,
        meta: {},
      },
      arguments
    ).pipe(delay(this.requestDelay));
  }

  private generateAccordingToDeployment(deployment: ILoggerDeploymentData): ILowestDecibelDateChartData {
    return generateDateDateChartData<ILowestDecibelDateChartDataValue, ILowestDecibelDateChartDataRange>(
      new Date().toISOString(),
      () => ({
        deploymentId: deployment.deploymentId,
        serialNo: deployment.serialNo,
        // this will be replaced!!!!
        collected: '',
        deployed: '',
      }),
      (date: string, index: number) => {
        const lowestNoiseDecibel = convertStringInToSumOfAllCharacters(date + deployment.deploymentId + 'db') % 60;

        const noSoundGroupSize = 7;
        const noSoundStartIndex = convertStringInToSumOfAllCharacters(deployment.deploymentId + 'db') % 25;
        const status =
          index >= noSoundStartIndex && index < noSoundStartIndex + noSoundGroupSize
            ? ChartDataSoundStatus.NoSound
            : undefined;

        return {
          date,
          lowestNoiseDecibel,
          status,
        };
      },
      [7, 11]
    );
  }
}
